import { type Session } from '@setplex/tria-api'

export const isGuestSession = (session: Session | null | undefined) =>
  session != null &&
  typeof session === 'object' &&
  typeof session.profileId === 'number' &&
  session.profileId < 0
